import { getParams, addParams } from '@dt/fe-utils'
import { getPlatform } from '@utils'
import mktController from 'controllers/mktController'
import { sanitizeShareUrl } from './shareUrl'

/**
 * 分享小程序
 * @param {string} router - 路由地址
 * @param {string} title - 分享标题
 * @param {string} imageUrl - 分享图
 * @param {boolean} isHref - 是否是url地址 true router整体是url地址
 */
interface IParams {
  mode?: 'all' | 'image' | 'card';
  scene?: string;
  router: string;
  title: string;
  imageUrl: string;
  isHref?: boolean;
  shareImageInfo?: any;
  price?: number;
  jumpH5Page?: string;
}
export const handleShareForWxa = ({
  mode = 'card',
  scene,
  router,
  title,
  imageUrl,
  isHref = false,
  shareImageInfo,
  price,
  jumpH5Page = ''
}: IParams) => {
  const { isWeixinMiniProgram } = getPlatform()
  const url = sanitizeShareUrl(isHref ? router : addParams({
    url: `${ENV.WEBSITE}${router}`,
    params: {
      ...getParams({ url: location.search })
    }
  }))
  if (isWeixinMiniProgram) {
    const shareInfo = {
      title,
      path: url,
      imageUrl,
      price
    }
    const path: string = `/pages/launch/index?state=share&sharePageInfo=${encodeURIComponent(JSON.stringify({ mode, scene, shareInfo: shareInfo, shareImageInfo, jumpH5Page }))}`
    window.wx?.miniProgram?.navigateTo({ url: path })
  } else if (url) {
    mktController.shareUrl(url)
  }
}
